import React, { useEffect, useState } from "react";
import style from "./forumCard.module.scss";
import toPersianNumber from "../../../helpers/actions/toPersianNumber";

const ForumCard = (props) => {

    const [liked, setLiked] = useState({
        isLiked: false,
        likeCount: props.data.like
    })

    const determineDate = date => {
        let current = new Date(date).toLocaleDateString('fa-IR')
        return current
    }

    const handleLike = async () => {
        let tmp = liked
        tmp.isLiked = !tmp.isLiked
        setLiked({ ...tmp })
        if (liked.isLiked) {
            tmp.likeCount = tmp.likeCount + 1
        } else {
            tmp.likeCount = tmp.likeCount - 1
        }
        setLiked({ ...tmp })
        await props.handleLike(props.data._id)
    }

    return (
        <div
            className={style.tableItem}
        >
            <div className={style.itemHeader}>
                <div className={style.profileIcon}>
                    <div className={style.iconWrapper}>
                        <div className={style.icon}></div>
                    </div>
                    <p className={style.text}>{typeof props.data != 'undefined' && props.data && props.data.name ? props.data.name : 'موبیشایی'}</p>
                </div>
                <div className={style.dateWrapper}>{determineDate(props.data.createDate)}</div>
            </div>

            <div className={style.shared}>
                <p>{props.data.content}</p>
            </div>

            <div className={style.actions}>
                <div className={style.actionItem} onClick={handleLike}>
                    <p className={liked.isLiked ? style.likedText : null}>{toPersianNumber(liked.likeCount)} نفر</p>
                    <div className={liked.isLiked ? style.liked : style.like}></div>
                </div>


                <div className={style.actionItem} onClick={() => props.handleComment(props.data, 1)}>
                    <p>{toPersianNumber(props.data.comment)} دیدگاه</p>
                    <div className={style.comment}></div>
                </div>
            </div>
        </div>
    );
}

export default ForumCard;